"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "perjantai",
    "MONDAY": "maanantai",
    "SATURDAY": "Lauantai",
    "SUNDAY": "sunnuntai",
    "THURSDAY": "torstai",
    "TUESDAY": "tiistai",
    "WEDNESDAY": "keskiviikko",
    "and": "ja",
    "day": "päivä",
    "day_one": "päivä",
    "day_other": "päivää",
    "day_plural": "päivää",
    "freeOfCharge": "Ilmainen",
    "hour_one": "tunnin",
    "hour_one_plural": "tuntia",
    "hour_other": "tuntia",
    "minute": "minuutti",
    "minute_one": "minuutti",
    "minute_other": "pöytäkirja",
    "ocpiRestrictionsAfterDuration": "{{minDuration}} jälkeen",
    "ocpiRestrictionsBetweenDuration": "{{minDuration}} - {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Ensimmäinen {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Kun energiankulutus on yli {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Kun energiankulutus välillä {{minKwh}} - {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Kun energiankulutus on alle {{maxKwh}}",
    "session": "istunto",
    "theDay": "päivä",
    "theDay_one": "päivä",
    "theDay_other": "päivää",
    "theHour": "tunnin",
    "theHour_one": "tunnin",
    "theHour_other": "tuntia",
    "theMinute": "minuutti",
    "theMinute_one": "minuutti",
    "theMinute_other": "pöytäkirja"
};
